import { jsx } from "react/jsx-runtime";
import { MarketingTypography } from "../MarketingTypography/index.js";
import { TextContainer } from "./styles.js";
const COMPONENT_NAME = "TextSection";
const TextSection = ({
  data,
  contentAlignment,
  globalTextColor,
  viewName
}) => {
  const { text_content } = data;
  if (!text_content || text_content.length <= 0) {
    return null;
  }
  const content = text_content.map((text, index) => {
    var _a, _b;
    if (!text.markdown_text) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      MarketingTypography,
      {
        color: ((_b = (_a = text.color) == null ? void 0 : _a.text_color) == null ? void 0 : _b.hex) || globalTextColor,
        component: text.select_semantics_type,
        variant: text.select_text_type,
        isMarkdown: true,
        id: `featurehighlightcard_text_${index}`,
        children: text.markdown_text
      },
      index
    );
  });
  return /* @__PURE__ */ jsx(
    TextContainer,
    {
      contentAlignment,
      "data-testid": `${viewName}-text-section`,
      children: content
    }
  );
};
TextSection.displayName = COMPONENT_NAME;
export {
  TextSection
};
